<template>
  <div class="dataAcquisitionBox">
    <div class="dataAcquisition">
      <DataStatus @getCollectCode="getCollectCode" />
      <UploadMode @onDetail="onDetail" :collectCode="status" :disabled="nextButtonDisable"/>
      <div class="errer-tip" v-show="errorText || status === '3'">
        <span v-if="status === '3'" class="icon iconfont icon-chenggong-mian"></span>
        <span v-else class="icon iconfont icon-v4-zhuyi-mian"></span>

        <div v-if="status === '3'">
          <div class="left-nowrap">发票数据已采集，查看发票详情后点击下一步。</div>
          <div class="center-nowrap">如有疑问，请联系您的客户经理。</div>
        </div>
        <span v-else>{{ errorText }}</span>
      </div>
      <div v-if="isBtmLoading" class="btm-loading">
        <van-loading size="24px" color="#fff">数据采集中...</van-loading>
      </div>
      <!-- 采集状态为“无数据”时，“下一步”按钮置灰-->
      <NextStep
        :disabled="nextButtonDisable"
        :isSwitch="isSwitch"
        :loading="loading"
        :loadingText="loadingText"
        :click="nextHandleClick"
      />

      <DetailsPopover
        v-model="isPopover"
        :title="popoverTitle"
        @onSubmit="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { Toast, Dialog } from 'vant';
import DataStatus from './components/DataStatus/index.vue';
import UploadMode from './components/UploadMode/index.vue';
import NextStep from './components/NextStep/index.vue';
import DetailsPopover from './components/DetailsPopover/index.vue';

export default {
  name: 'DataAcquisition',
  components: {
    DataStatus,
    DetailsPopover,
    UploadMode,
    NextStep,
  },
  data() {
    return {
      isSwitch: '1', // 1 :下一步 2: 返回 3: 不显示按钮
      status: '0', // 采集状态 0无数据 1处理中 2采集失败 3数据处理完成
      loading: false,
      loadingText: '加载中',
      redirectPage: '',
      isPopover: false,
      popoverTitle: '',
      errorText: '',
      isBtmLoading:false
    };
  },
  mounted() {
    // statusCode 1: 下一步 2: 返回
    this.isSwitch = this.$route.query.statusCode || '1';
    console.log('oooooooooo', this.$route.query);
    this.redirectPage = decodeURIComponent(this.$route.query.redirect || '');
    if (this.redirectPage === '/supermarket/v2/bindEnterprise') {
      window.document.title = '经营数据';
    }
    if(this.$route.query.back=='1'){
      localStorage.setItem('backToData','1')
      this.isBtmLoading = true
    }else if(localStorage.getItem('backToData')=='1'){
      this.isBtmLoading = true
    }
  },
  computed: {
    nextButtonDisable() {
      if (this.isSwitch === '2') {
        return false;
      }
      if (this.status !== '3') {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('commonForms', ['getModel']),
    ...mapMutations('commonForms', ['updateForm']),
    onDetail() {
      if (this.nextButtonDisable) return;
      this.isPopover = true;
      this.popoverTitle = '发票详情';
    },
    getCollectCode({ collectCode = '', collectMessage = '' }) {
      this.status = collectCode;
      if(collectCode=='2'||collectCode=='3'){
        localStorage.removeItem('backToData')
        this.isBtmLoading = false
      }
      // 采集回来状态没更新到采集中时
      if(this.isBtmLoading){
        this.errorText = this.errorMapping('1')
      }else{
        this.errorText = this.errorMapping(collectCode);
      }
    },
    // 错误映射
    errorMapping(val) {
      // status: '0', // 采集状态 0无数据 1处理中 2采集失败 3数据处理完成
      switch (val) {
        case '0':
          return '请点击“去采集”, 您需要先进行发票数据采集操作。';
        case '1':
          return '发票数据采集中, 大约需要5分钟, 请您耐心等待, 谢谢！';
        case '2':
          return '发票数据采集失败, 您可以点击“去采集”, 重新进行发票数据采集操作, 或联系您的客户经理。';
        default:
          break;
      }
    },
    uploadModel() {
      Dialog.confirm({
        title: '提示',
        message: '暂无发票数据，请先上传后再继续下一步操作。若已上传，请耐心等待。',
        confirmButtonText: '去上传',
        cancelButtonText: '取消',
      }).then(() => {
        this.jumpRpa();
      });
    },
    async jumpRpa() {
      const {
        orderId, taxNo, name, identity, corpName,
      } = this.$route.query;
      const { returnCode, data, returnMessage } = await this.$api.PublicPage.getRpaUrl({
        jumpUrl: window.location.href,
        orderId,
        taxNo,
        name,
        identity,
        corpName,
      });
      if (returnCode === '200') {
        window.location.href = data.url;
      } else {
        this.$toast(returnMessage || '获取链接失败，请稍后再试。');
      }
    },
    async onSubmit() {
      this.updateForm({
        orderId: this.$route.query.orderId,
      });
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });

      if (this.$route.query.jumpType === '1') {
        this.$api.CommonForms.nextJumpPageServer({
          orderId: this.$route.query.orderId,
        }).then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            } else {
              Toast('跳转链接获取失败');
            }
          } else {
            Toast(res.returnMessage || '接口异常');
          }
          this.$loading.hide();
        });
      } else {
        // 是否需要跳转选择核心企业
        const { success, data, returnMessage } = await this.$api.CommonForms.getCoreCorpPage({
          orderId: this.$route.query.orderId,
        });
        if (success) {
          ['1', '2'].includes(data.type) ? window.location.href = data.url : this.getModel(); // 调用跑模型接口
        } else {
          Toast(returnMessage);
        }
      }
    },
    nextHandleClick() {
      // 普惠税贷按钮置灰可点，弹窗引导数据上传
      if (this.nextButtonDisable) {
        this.$route.query.productId === 'SPDB-PHD' && this.uploadModel();
      } else {
        // PF-PWDX 浦发新产品不需要弹框提示
        if (this.$route.query.productId === 'PF-PWDX' && this.isSwitch === '1') {
          if (this.status === '3') {
            this.onSubmit();
          } else {
            Toast('数据处理未完成，请稍后重试');
          }
          return;
        }

        if (this.isSwitch === '2') {
          return this.$router.push(this.redirectPage);
        };
        const { dataWhiteList } = this.$api.CommonForms;
        dataWhiteList({ orderId: this.$route.query.orderId }).then((res) => {
          if (res.returnCode === '200') {
            if (res.data.status === '0') {
              Toast(res.data.message);
            } else {
              this.isPopover = true;
              this.popoverTitle = '请确认发票数据';
            }
          } else {
            Toast(res.data.message);
          }
        });
      }
    },
  },
};

</script>
<style scoped lang="scss">
.errer-tip{
  background: rgba(255, 101, 56, 0.1);
  padding: 4px 8px 4px 24px;
  display: inline-flex;
  align-items: center;
  margin: 16px 16px 0 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  position: relative;
  .left-nowrap{
    text-align: left; white-space: nowrap;
  }
  .center-nowrap{
    text-align: center; white-space: nowrap;
  }
  .icon-v4-zhuyi-mian{
    color: var(--var-primary-color, rgb(255, 101, 56));
    margin-right: 4px;
    position: absolute;
    top: 5px;
    left: 7px;
  }
  .icon-chenggong-mian{
    color: var(--var-primary-color, rgb(89,156,12));
    margin-right: 4px;
    position: absolute;
    top: 5px;
    left: 7px;
  }
}
.btm-loading{
  position: absolute;
  bottom: 80px;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 8px 16px;
  border-radius: 8px;
  transform: translateX(-50%);
}

</style>
